import { Button, Group, Stack } from '@mantine/core';
import { zodResolver } from '@mantine/form';
import { modals } from '@mantine/modals';
import z from 'zod';

import { Declarant } from '@e-origin/shared';

import { UploadFile } from '@components';
import { useFormWithNameInputProp } from '@hooks/useFormWithNameInputProp';
import { useDeleteDeclarantLogo, useEditDeclarantLogo } from '../../hooks';

interface EditDeclarantLogoProps {
  declarant: Declarant;
}

const EditDeclarantLogoSchema = z.object({
  logo: z.instanceof(File),
});

type EditDeclarantLogoValues = z.infer<typeof EditDeclarantLogoSchema>;

export const EditDeclarantLogo: React.FC<EditDeclarantLogoProps> = ({ declarant }) => {
  const editDeclarantLogoMutation = useEditDeclarantLogo();
  const deleteDeclarantLogoMutation = useDeleteDeclarantLogo();

  const form = useFormWithNameInputProp<EditDeclarantLogoValues>({
    initialValues: {
      logo: null,
    },
    validate: zodResolver(EditDeclarantLogoSchema),
    validateInputOnBlur: true,
  });

  const handleSubmit = async () => {
    await editDeclarantLogoMutation.mutateAsync({ declarantId: declarant._id, file: form.values.logo }, { onSuccess: () => modals.closeAll() });
  };

  const handleDelete = async () => {
    await deleteDeclarantLogoMutation.mutateAsync(declarant._id, { onSuccess: () => modals.closeAll() });
  };

  return (
    <Stack>
      <UploadFile type="image" isMulti={false} {...form.getInputProps('logo')} description="Upload jpeg or png logo" />

      <Group justify="center" mt="md">
        <Button type="button" onClick={handleSubmit} variant="filled" size="lg" disabled={!form.values.logo}>
          Save
        </Button>
        <Button type="button" onClick={() => modals.closeAll()} variant="outline" size="lg">
          Cancel
        </Button>
        {declarant.logo && (
          <Button type="button" color="red" onClick={handleDelete} variant="filled" size="lg">
            Delete Logo
          </Button>
        )}
      </Group>
    </Stack>
  );
};
